// TODO: does not belong in constants, move it to config
export default {
  TIME_ZONE: 'Australia/Sydney',
  DATE_TIME_FORMAT: 'YYYY-MM-DD HH:mm'
};
